import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { reduxForm, Field, submit } from 'redux-form'
import TextField from 'forms/shared/fields/text'
import validate from './validator'

const inputClass = `
  shadow-sm
  appearance-none border-r border-l
  border-t border-r border-b rounded-l-md
  leading-tight
  text-gray-700 leading-tight
  focus:border-primary-orange`

const labelClass = `capitalize block font-semibold text-xs mb-1`

const SendInviteForm = ({ dispatch, form }) => {
  return (
    <div className="flex items-end">
      <Field
        type={'text'}
        name={`email`}
        label={'Email address'}
        placeholder="Type an email"
        groupClassName="w-2/3 relative"
        labelClassName={labelClass}
        inputClassName={`${inputClass} py-3 px-3 w-full`}
        inputErrorClassName={''}
        errorClassName="text-red-500 text-xs italic absolute"
        component={TextField}
      />
      <div className="pt-2 w-1/3">
        <button onClick={() => dispatch(submit(form))} className="w-full py-3 flex justify-center border-b border-primary-orange items-center btn-primary text-sm font-semibold rounded-r-md">Send Invite</button>
      </div>
    </div>
  )
}

SendInviteForm.propTypes = {
  dispatch: PropTypes.func,
  form: PropTypes.string
}

export default reduxForm({ validate, enableReinitialize: true })(connect()(SendInviteForm))
